/**
 * Created by Alex Bol on 3/28/2017.
 */

'use strict';

module.exports = {
    RB_TREE_COLOR_RED: 0,
    RB_TREE_COLOR_BLACK: 1
};